import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';
import { RecruitApi } from './core/api/recruit-api';
import { HttpRecruitApi } from './core/api/http-recruit-api';
import { MockRecruitApi } from './core/api/mock/mock-recruit-api';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    { provide: RecruitApi, useClass: environment.useMocks ? MockRecruitApi : HttpRecruitApi },
  ],
};
